// extracted by mini-css-extract-plugin
export default {"header":"remove_header__wPqB+","info":"remove_info__etvEp","btnContainer":"remove_btnContainer__v543o","cancel":"remove_cancel__mtUv+","confirm":"remove_confirm__BRGKY"};